import { setIsPending } from '@gef-ui/redux-common/actions/appContext';
import { isPending } from '@gef-ui/redux-common/selectors/appContext';
import sleep from "@gef-ui/utils/sleep";
import invariant from 'invariant';
import mergeRight from "ramda/es/mergeRight";
import { MIDDLEWARE_NAME as OAUTH2_MIDDLEWARE_NAME } from '../../../middleware/oauth2/constants';
import { withLogout } from '../../access/facade';
import { setAccessToken, setRefreshToken } from '../actions';
import { OBTAIN_TOKENS_REQUEST_ID } from '../constants';
import logout from '../logout';
import postOauthFormEncoded from '../postOAuthFormEncodedFacade';
import { getCode, getOauthBodyWithAuthorizationGrantType } from '../selectors';
import { decodeCode, viewCode } from '../utils';
export default ((body = {}, beforeLogout)=>async (dispatch, getState)=>{
        const state = getState();
        const code = getCode(state) || viewCode(body);
        invariant(code, 'Unable to obtain oauth2 access and refresh tokens without code.');
        if (isPending(state)) {
            while(isPending(getState())){
                await sleep(500);
            }
            return Promise.resolve();
        }
        dispatch(setIsPending(true));
        return dispatch(withLogout(postOauthFormEncoded, logout)({
            endpoint: ({ urls })=>`${urls.token}`,
            body: decodeCode(mergeRight(getOauthBodyWithAuthorizationGrantType(state), body)),
            actions: {
                onSuccess: [
                    setAccessToken,
                    setRefreshToken,
                    setIsPending(false)
                ],
                onError: setIsPending(false)
            },
            beforeLogout,
            meta: {
                requestUuid: OBTAIN_TOKENS_REQUEST_ID
            },
            middlewares: {
                [OAUTH2_MIDDLEWARE_NAME]: {
                    skip: true
                }
            }
        }));
    });
